import React from 'react';

const StatCards = ({cards}) => {
    return <div className="grid grid-flow-col auto-cols-fr gap-2">
        {cards && cards.map((card, i) => {
            return <Card key={i} {...card} />
        })}
    </div>
}

const Card = ({title, value}) => {
    return <div className="bg-slate-50 rounded-lg p-4 border">
        <p className="text-gray-600 font-bold text-sm mb-2">{title}</p>
        <div className="text-brand text-4xl text-center">
            {value}
        </div>
    </div>
}

export default StatCards;
